module.exports = __webpack_public_path__ + "static/media/eyes-closed.94975a30.svg";